import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { StorageKey } from '../utils/helper.type';
import { RouteProps } from './route.type';

export const UnauthenticatedWrapper: FC<RouteProps> = (props) => {
  const token: string | null = localStorage.getItem(StorageKey.ACCESS_TOKEN);

  if (token) {
    return <Navigate to="/dashboard" />;
  }

  return <>{props.children}</>;
};
